export const DISCUSSION_ROOM_WIDGET_INSTRUCTION_DISMISSED_KEY = 'discussion-room-widget-instructions-dismissed';
